import { useContext } from 'react';
import { UIVersionContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const V1AccountsOnly = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { uiVersion } = useContext(UIVersionContext);

  if (uiVersion !== 'v1') {
    return null;
  }

  return <>{children}</>;
};

export default V1AccountsOnly;
